import { createFileRoute } from "@tanstack/react-router";
import { PositionSizeCalculator } from "@/components/tools/PositionSizeCalculator";

export const Route = createFileRoute("/_authenticated/dashboard/tools")({
  head: () => ({
    meta: [
      { title: "Gold Risk Calculator | XAU Pro Academy" },
      {
        name: "description",
        content: "XAUUSD position size, margin and prop firm daily drawdown room for members.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: TradingToolsPage,
});

function TradingToolsPage() {
  return (
    <div className="container mx-auto max-w-6xl px-4 py-10 md:py-14">
      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold">Risk desk</div>
      <h1 className="mt-2 font-display text-3xl font-semibold md:text-4xl">Gold Position Size Calculator</h1>
      <p className="mt-2 max-w-2xl text-muted-foreground">
        Size every XAUUSD position against your stop, balance and remaining daily loss allowance.
      </p>
      <div className="mt-8">
        <PositionSizeCalculator goldOnly />
      </div>
      <p className="mt-4 text-[11px] text-muted-foreground">
        Based on a 100 oz standard contract. Confirm your broker's contract specification before execution.
      </p>
    </div>
  );
}
